import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: any;
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: any;
  /** A field whose value is a UTC Offset: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
  UtcOffset: any;
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  Duration: any;
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  ISO8601Duration: any;
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: any;
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`. */
  LocalTime: any;
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`.  This scalar is very similar to the `LocalTime`, with the only difference being that `LocalEndTime` also allows `24:00` as a valid value to indicate midnight of the following day.  This is useful when using the scalar to represent the exclusive upper bound of a time block. */
  LocalEndTime: any;
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  EmailAddress: any;
  /** Floats that will have a value less than 0. */
  NegativeFloat: any;
  /** Integers that will have a value less than 0. */
  NegativeInt: any;
  /** A string that cannot be passed as an empty value */
  NonEmptyString: any;
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: any;
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: any;
  /** Floats that will have a value of 0 or less. */
  NonPositiveFloat: any;
  /** Integers that will have a value of 0 or less. */
  NonPositiveInt: any;
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: any;
  /** Floats that will have a value greater than 0. */
  PositiveFloat: any;
  /** Integers that will have a value greater than 0. */
  PositiveInt: any;
  /** A field whose value conforms to the standard postal code formats for United States, United Kingdom, Germany, Canada, France, Italy, Australia, Netherlands, Spain, Denmark, Sweden, Belgium, India, Austria, Portugal, Switzerland or Luxembourg. */
  PostalCode: any;
  /** Floats that will have a value of 0 or more. */
  UnsignedFloat: any;
  /** Integers that will have a value of 0 or more. */
  UnsignedInt: any;
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: any;
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: any;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: any;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  GUID: any;
  /** A field whose value is a hexadecimal: https://en.wikipedia.org/wiki/Hexadecimal. */
  Hexadecimal: any;
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: any;
  /** A field whose value is a CSS HSL color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSL: any;
  /** A field whose value is a CSS HSLA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSLA: any;
  /** A field whose value is a IPv4 address: https://en.wikipedia.org/wiki/IPv4. */
  IPv4: any;
  /** A field whose value is a IPv6 address: https://en.wikipedia.org/wiki/IPv6. */
  IPv6: any;
  /** A field whose value is a ISBN-10 or ISBN-13 number: https://en.wikipedia.org/wiki/International_Standard_Book_Number. */
  ISBN: any;
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: any;
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: any;
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: any;
  /** A field whose value is a IEEE 802 48-bit MAC address: https://en.wikipedia.org/wiki/MAC_address. */
  MAC: any;
  /** A field whose value is a valid TCP port within the range of 0 to 65535: https://en.wikipedia.org/wiki/Transmission_Control_Protocol#TCP_ports */
  Port: any;
  /** A field whose value is a CSS RGB color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGB: any;
  /** A field whose value is a CSS RGBA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGBA: any;
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: any;
  /** A currency string, such as $21.25 */
  USCurrency: any;
  /** A field whose value is a Currency: https://en.wikipedia.org/wiki/ISO_4217. */
  Currency: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** A field whose value is an International Bank Account Number (IBAN): https://en.wikipedia.org/wiki/International_Bank_Account_Number. */
  IBAN: any;
  /** A field whose value conforms with the standard mongodb object ID as described here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId. Example: 5e5677d71bdc2ae76344968c */
  ObjectID: any;
  /** Represents NULL values */
  Void: any;
  /** A field whose value conforms to the standard DID format as specified in did-core: https://www.w3.org/TR/did-core/. */
  DID: any;
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: any;
  /** The locale in the format of a BCP 47 (RFC 5646) standard string */
  Locale: any;
  /** In the US, an ABA routing transit number (`ABA RTN`) is a nine-digit code to identify the financial institution. */
  RoutingNumber: any;
  /** Banking account number is a string of 5 to 17 alphanumeric values for representing an generic account number */
  AccountNumber: any;
  /** A field whose value conforms to the standard cuid format as specified in https://github.com/ericelliott/cuid#broken-down */
  Cuid: any;
};

export type Query = {
  __typename?: 'Query';
  client: Client;
  listClients: PaginatedClients;
  company?: Maybe<Company>;
  listCompanies: PaginatedCompanies;
  listCompanyAPIKeys: Array<Credential>;
  listClientAPIKeys: Array<Credential>;
  listServiceAPIs: Array<ServiceApi>;
  user: User;
  listUsers: PaginatedUsers;
  isSessionValid?: Maybe<Scalars['Boolean']>;
};

export type QueryClientArgs = {
  id: Scalars['ObjectID'];
};

export type QueryListClientsArgs = {
  input: ListClientsInput;
};

export type QueryCompanyArgs = {
  id: Scalars['ObjectID'];
};

export type QueryListCompaniesArgs = {
  input: PaginatedCompaniesInput;
};

export type QueryListCompanyApiKeysArgs = {
  id: Scalars['ObjectID'];
};

export type QueryListClientApiKeysArgs = {
  id: Scalars['ObjectID'];
};

export type QueryUserArgs = {
  id?: Maybe<Scalars['String']>;
};

export type QueryListUsersArgs = {
  input: PaginatedUsersInput;
};

export type QueryIsSessionValidArgs = {
  token: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createClient: Client;
  updateClient: Client;
  deleteClient: Client;
  createCompany: Company;
  updateCompany: Company;
  deleteCompany: Company;
  createAPIKey: Credential;
  updateAPIKey: Credential;
  deleteCredential: Credential;
  createServiceAPI: ServiceApi;
  updateServiceAPI: ServiceApi;
  deleteServiceAPI: ServiceApi;
  createUser: User;
  updateUser: User;
  authenticate: AuthenticationResponse;
};

export type MutationCreateClientArgs = {
  input: CreateClientInput;
};

export type MutationUpdateClientArgs = {
  input: UpdateClientInput;
};

export type MutationDeleteClientArgs = {
  id: Scalars['ObjectID'];
};

export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};

export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};

export type MutationDeleteCompanyArgs = {
  id: Scalars['ObjectID'];
};

export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};

export type MutationUpdateApiKeyArgs = {
  input: UpdateApiKeyInput;
};

export type MutationDeleteCredentialArgs = {
  id: Scalars['ObjectID'];
};

export type MutationCreateServiceApiArgs = {
  input: CreateServiceApiInput;
};

export type MutationUpdateServiceApiArgs = {
  input: UpdateServiceApiInput;
};

export type MutationDeleteServiceApiArgs = {
  id: Scalars['ObjectID'];
};

export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationAuthenticateArgs = {
  input: AuthenticateUserInput;
};

export type UpdateClientInput = {
  _id: Scalars['ObjectID'];
  name: Scalars['String'];
  enabled?: Maybe<Scalars['Boolean']>;
};

export type CreateClientInput = {
  name: Scalars['String'];
  companyId: Scalars['ObjectID'];
  enabled?: Maybe<Scalars['Boolean']>;
};

export type ListClientsInput = {
  companyId: Scalars['ObjectID'];
  page?: Scalars['Int'];
  limit?: Scalars['Int'];
  searchTerm?: Maybe<Scalars['String']>;
};

export type PaginatedClients = {
  __typename?: 'PaginatedClients';
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Client>>;
};

export type Client = {
  __typename?: 'Client';
  _id: Scalars['ObjectID'];
  companyId?: Maybe<Scalars['ObjectID']>;
  name?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  company?: Maybe<Company>;
};

export type UpdateCompanyInput = {
  _id: Scalars['ObjectID'];
  name: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type CreateCompanyInput = {
  name: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type PaginatedCompaniesInput = {
  page?: Scalars['Int'];
  limit?: Scalars['Int'];
  searchTerm?: Maybe<Scalars['String']>;
};

export type PaginatedCompanies = {
  __typename?: 'PaginatedCompanies';
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Company>>;
};

export type Company = {
  __typename?: 'Company';
  _id: Scalars['ObjectID'];
  legacyId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  address?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
};

export enum CredentialUsageTypeEnum {
  RateFiling = 'RATE_FILING',
  Development = 'DEVELOPMENT',
  Production = 'PRODUCTION',
  Claims = 'CLAIMS',
  Underwriting = 'UNDERWRITING',
}

export type UpdateApiKeyInput = {
  _id: Scalars['ObjectID'];
  name: Scalars['String'];
  allowedApis?: Maybe<Array<Scalars['ObjectID']>>;
  enabled?: Maybe<Scalars['Boolean']>;
  usageType: CredentialUsageTypeEnum;
};

export type CreateApiKeyInput = {
  name: Scalars['String'];
  companyId: Scalars['ObjectID'];
  clientId?: Maybe<Scalars['ObjectID']>;
  allowedApis?: Maybe<Array<Scalars['ObjectID']>>;
  enabled?: Maybe<Scalars['Boolean']>;
  usageType: CredentialUsageTypeEnum;
};

export type Credential = {
  __typename?: 'Credential';
  _id: Scalars['ObjectID'];
  companyId?: Maybe<Scalars['ObjectID']>;
  clientId?: Maybe<Scalars['ObjectID']>;
  legacyId?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  allowedApis?: Maybe<Array<ServiceApi>>;
  deleted?: Maybe<Scalars['Boolean']>;
  expiresTimestamp?: Maybe<Scalars['Int']>;
  generatedKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  willExpire?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  company?: Maybe<Company>;
  client?: Maybe<Client>;
  usageType?: Maybe<CredentialUsageTypeEnum>;
};

export type CreateServiceApiInput = {
  endpoints?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type UpdateServiceApiInput = {
  _id: Scalars['ObjectID'];
  endpoints?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type ServiceApi = {
  __typename?: 'ServiceAPI';
  _id: Scalars['ObjectID'];
  legacyId?: Maybe<Scalars['String']>;
  endpoints?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
};

export type AuthenticationResponse = {
  __typename?: 'AuthenticationResponse';
  error?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type AuthenticateUserInput = {
  username: Scalars['String'];
  password: Scalars['String'];
};

export type PaginatedUsersInput = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
};

export type UpdateUserInput = {
  _id: Scalars['ObjectID'];
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
};

export type CreateUserInput = {
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
};

export type PaginatedUsers = {
  __typename?: 'PaginatedUsers';
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  results?: Maybe<Array<User>>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ObjectID'];
  legacyId?: Maybe<Scalars['String']>;
  actorType?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  deleted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type IsSessionValidQueryVariables = Exact<{
  token: Scalars['String'];
}>;

export type IsSessionValidQuery = { __typename?: 'Query' } & Pick<
  Query,
  'isSessionValid'
>;

export type AuthenticateMutationVariables = Exact<{
  input: AuthenticateUserInput;
}>;

export type AuthenticateMutation = { __typename?: 'Mutation' } & {
  authenticate: { __typename?: 'AuthenticationResponse' } & Pick<
    AuthenticationResponse,
    'error' | 'message' | 'token'
  >;
};

export const IsSessionValidDocument = gql`
  query isSessionValid($token: String!) {
    isSessionValid(token: $token)
  }
`;

/**
 * __useIsSessionValidQuery__
 *
 * To run a query within a React component, call `useIsSessionValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsSessionValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsSessionValidQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useIsSessionValidQuery(
  baseOptions: Apollo.QueryHookOptions<
    IsSessionValidQuery,
    IsSessionValidQueryVariables
  >
) {
  return Apollo.useQuery<IsSessionValidQuery, IsSessionValidQueryVariables>(
    IsSessionValidDocument,
    baseOptions
  );
}
export function useIsSessionValidLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IsSessionValidQuery,
    IsSessionValidQueryVariables
  >
) {
  return Apollo.useLazyQuery<IsSessionValidQuery, IsSessionValidQueryVariables>(
    IsSessionValidDocument,
    baseOptions
  );
}
export type IsSessionValidQueryHookResult = ReturnType<
  typeof useIsSessionValidQuery
>;
export type IsSessionValidLazyQueryHookResult = ReturnType<
  typeof useIsSessionValidLazyQuery
>;
export type IsSessionValidQueryResult = Apollo.QueryResult<
  IsSessionValidQuery,
  IsSessionValidQueryVariables
>;
export const AuthenticateDocument = gql`
  mutation Authenticate($input: AuthenticateUserInput!) {
    authenticate(input: $input) {
      error
      message
      token
    }
  }
`;
export type AuthenticateMutationFn = Apollo.MutationFunction<
  AuthenticateMutation,
  AuthenticateMutationVariables
>;

/**
 * __useAuthenticateMutation__
 *
 * To run a mutation, you first call `useAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateMutation, { data, loading, error }] = useAuthenticateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AuthenticateMutation,
    AuthenticateMutationVariables
  >
) {
  return Apollo.useMutation<
    AuthenticateMutation,
    AuthenticateMutationVariables
  >(AuthenticateDocument, baseOptions);
}
export type AuthenticateMutationHookResult = ReturnType<
  typeof useAuthenticateMutation
>;
export type AuthenticateMutationResult = Apollo.MutationResult<
  AuthenticateMutation
>;
export type AuthenticateMutationOptions = Apollo.BaseMutationOptions<
  AuthenticateMutation,
  AuthenticateMutationVariables
>;
